import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import RuleConnector from './RuleConnector';
const RuleContainer = props => {
    const { show, unchecked, background, borderColor, hideConnector, customConnector, className, children } = props, remainingProps = __rest(props, ["show", "unchecked", "background", "borderColor", "hideConnector", "customConnector", "className", "children"]);
    if (!show) {
        return null;
    }
    const boxClassNames = classNames('RuleContainerBox', 'position-relative', 'rounded padding-20', background, unchecked && `border border-width border-style-dashed ${borderColor}`, className);
    return (_jsxs("div", Object.assign({ className: 'RuleContainer' }, remainingProps, { children: [_jsx("div", Object.assign({ className: boxClassNames, "data-testid": 'ruleContainerBox' }, { children: _jsx(AnimatePresence, Object.assign({ exitBeforeEnter: true }, { children: React.Children.map(children, child => {
                        var _a;
                        if (!child) {
                            return null;
                        }
                        // In case there are multiple children of RuleContainer, use the
                        // type name or the type itself as a key to animate between the two children
                        return (_jsx(motion.div, Object.assign({ initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, { children: child }), ((_a = child.type) === null || _a === void 0 ? void 0 : _a.name) || child.type));
                    }) })) })), customConnector ? customConnector : _jsx(RuleConnector, { hidden: unchecked || hideConnector })] })));
};
RuleContainer.defaultProps = {
    show: true,
    unchecked: false,
    background: 'bg-lightest',
    borderColor: '',
    hideConnector: false,
    className: '',
};
RuleContainer.propTypes = {
    show: PropTypes.bool,
    unchecked: PropTypes.bool,
    background: PropTypes.string,
    borderColor: PropTypes.string,
    hideConnector: PropTypes.bool,
    customConnector: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
};
export default RuleContainer;
